import { LoadingErrorProps } from './LoadingErrorComponent';
import { IconButton, Stack, Typography } from '@mui/material';
import { Cached } from '@mui/icons-material';
import { useSharedTranslation } from '@shared/i18n';

export function DefaultPpsErrorFallback({ reload, error }: LoadingErrorProps) {
  const { t } = useSharedTranslation();

  return (
    <Stack alignItems="center" spacing={2}>
      <Typography variant="h1" component="p" sx={{ color: 'warning.main' }}>
        {t('shared.error.oops')}
      </Typography>
      <Typography variant="body1">{t('shared.error.content')}</Typography>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="body1">{t('shared.error.message')}:</Typography>
        <code>{error}</code>
      </Stack>
      {reload && (
        <>
          <IconButton onClick={reload}>
            <Cached sx={{ fontSize: '62px', transform: 'scaleX(-1) rotate(45deg)' }} />
          </IconButton>
          <Typography variant="body1">{t('shared.error.retry')}</Typography>
        </>
      )}
    </Stack>
  );
}
